import type { FC, PropsWithChildren } from "react";

import { isEditing } from "@builder.io/sdk-react";

import type { AccordionItemIdentifier } from "@jti/core-components/components/Accordion";
import { Accordion as CoreAccordion } from "@jti/core-components/components/Accordion";
import { dispatchTrackingEvent, TrackingEvents } from "@jti/tracker";

import { getBuilderChildrenCount } from "@/libs/builder/utils/getBuilderChildrenCount";

import { Placeholder } from "../Placeholder/Placeholder";

import type { accordionInputs } from "./Accordion.builder";

import styles from "./Accordion.module.scss";

export type AccordionBuilderProps = BuilderComponentProps<typeof accordionInputs>;

export const Accordion: FC<PropsWithChildren<AccordionBuilderProps>> = ({
  children,
  singleExpanded,
  trackingEventType,
}) => {
  const handleToggle = ({ title }: AccordionItemIdentifier, isExpanded: boolean) => {
    if (!isExpanded) return;

    const trackingMap = {
      faq: {
        name: TrackingEvents.TrackingFaqLink,
        value: {
          faq_name: title,
        },
      },
    };

    if (trackingEventType && trackingEventType in trackingMap) {
      const { name, value } = trackingMap[trackingEventType as keyof typeof trackingMap];
      dispatchTrackingEvent(name, value);
    }
  };

  if (getBuilderChildrenCount(children) === 0 && isEditing()) {
    return <Placeholder>Drag and drop Accordion Item components here</Placeholder>;
  }

  return (
    <div className={styles.accordionWrapper}>
      <CoreAccordion singleExpanded={singleExpanded} onToggle={handleToggle}>
        {children}
      </CoreAccordion>
    </div>
  );
};
